import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon, LayersIcon, ArrowUpRightIcon } from 'lucide-react';
interface QuickLink {
  label: string;
  href: string;
}
const QUICK_LINKS: QuickLink[] = [{
  label: 'El Mega Pack 6 en 1',
  href: '#tomos'
}, {
  label: 'Beneficios',
  href: '#beneficios'
}, {
  label: 'Para quién es',
  href: '#para-quien'
}, {
  label: 'Bonos',
  href: '#bonos'
}, {
  label: 'Preguntas frecuentes',
  href: '#faq'
}, {
  label: 'Precio y acceso',
  href: '#comprar'
}];
const LEGAL_LINKS: QuickLink[] = [{
  label: 'Términos y condiciones',
  href: '#faq'
}, {
  label: 'Política de privacidad',
  href: '#faq'
}, {
  label: 'Política de reembolso',
  href: '#faq'
}];
export function Footer() {
  return <footer id="site-footer" className="relative overflow-hidden bg-sand" data-id="element-99" data-mp="3qcdtr3ly4ftg">
      <div className="h-px w-full bg-gold/30" aria-hidden data-id="element-100" data-mp="29ynnprb9nhh6" />
      <div className="pointer-events-none absolute -bottom-28 -right-20 h-72 w-72 rounded-full bg-stone/50 blur-3xl" aria-hidden data-id="element-101" data-mp="2a19tbleljmwr" />

      <div className="relative mx-auto max-w-6xl px-5 py-12 sm:py-14" data-id="element-102" data-mp="3l8qxu8j60rtk">
        <div className="grid gap-8 md:grid-cols-3 md:gap-8 lg:gap-12" data-id="element-103" data-mp="3gapc1fucueee">
          {/* Marca y producto */}
          <div className="md:col-span-1" data-id="element-104" data-mp="3v7gbtq7xxs4j">
            <p className="font-display text-2xl font-bold uppercase leading-tight text-charcoal" data-id="element-105" data-mp="3v9b1fhu5q8ey">
              Coach Digital <span className="text-gold-deep" data-id="element-106" data-mp="3q7bwi3irr3fw">PRO</span>
            </p>
            <p className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-gold/40 bg-ivory px-3 py-1 text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-107" data-mp="81pghm1kl3ay">
              <LayersIcon className="h-3 w-3 text-gold-deep" aria-hidden data-id="element-108" data-mp="hrs6dddea152" />
              Mega Pack 6 en 1
            </p>
            <p className="mt-4 max-w-sm text-[0.82rem] leading-relaxed text-charcoal/65" data-id="element-109" data-mp="cu8uul8302gt">
              El sistema para coaches y profesionales que venden conocimiento, sesiones, programas y
              acompañamientos, y quieren convertir su presencia digital en una fuente real de
              clientes.
            </p>
            <p className="mt-4 max-w-sm font-display text-sm font-bold uppercase leading-snug text-charcoal/80" data-id="element-110" data-mp="tt0bcx16uytn">
              Convertí tu conocimiento en clientes.
            </p>
          </div>

          {/* Enlaces rápidos */}
          <nav aria-label="Enlaces rápidos" data-id="element-111" data-mp="18kiw184zthjc">
            <h2 className="text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-112" data-mp="18lkbdot1kq6v">
              Explorá el pack
            </h2>
            <ul className="mt-4 space-y-2" data-id="element-113" data-mp="1hkfg0wgfts82">
              {QUICK_LINKS.map(link => <li key={link.label} data-id="element-114" data-mp="1mjsbg5ldk7m9">
                  <a href={link.href} className="group inline-flex items-center gap-1.5 text-[0.82rem] text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-115" data-mp="1mktqel5ihe99">
                    {link.label}
                    <ArrowUpRightIcon className="h-3.5 w-3.5 text-gold/60 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-gold-deep" aria-hidden data-id="element-116" data-mp="3tc2vszgywvg4" />
                  </a>
                </li>)}
            </ul>
          </nav>

          {/* Soporte */}
          <div data-id="element-117" data-mp="1wpa3x7viqj9w">
            <h2 className="text-[0.62rem] font-semibold uppercase tracking-editorial text-gold-deep" data-id="element-118" data-mp="1wlm9m6i91su4">
              Soporte
            </h2>
            <ul className="mt-4 space-y-2 text-[0.82rem]" data-id="element-119" data-mp="2pbuw2ajtizei">
              <li data-id="element-120" data-mp="2pa9wu7mk6sab">
                <a href="mailto:soporte@creativodigital.shop" className="inline-flex items-center gap-2.5 text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-121" data-mp="2kdb9c7xehjl3">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ivory ring-1 ring-stone" data-id="element-122" data-mp="13zbbr3m12610">
                    <MailIcon className="h-4 w-4 text-gold-deep" aria-hidden data-id="element-123" data-mp="2ruofb3q8cfxu" />
                  </span>
                  soporte@creativodigital.shop
                </a>
              </li>
              <li data-id="element-124" data-mp="2ivufz5lilbgl">
                <a href="https://instagram.com/creativodigitalstudio" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-125" data-mp="2iwcg4dbas9ts">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ivory ring-1 ring-stone" data-id="element-126" data-mp="31khj3ik4rqrj">
                    <InstagramIcon className="h-4 w-4 text-gold-deep" aria-hidden data-id="element-127" data-mp="36issjs6ijz98" />
                  </span>
                  @creativodigitalstudio
                </a>
              </li>
              <li data-id="element-128" data-mp="1v71pvprkpxtw">
                <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 text-charcoal/70 transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-129" data-mp="1v3duel2kj1cj">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-ivory ring-1 ring-stone" data-id="element-130" data-mp="1roueka190558">
                    <GlobeIcon className="h-4 w-4 text-gold-deep" aria-hidden data-id="element-131" data-mp="13vvradcveolv" />
                  </span>
                  www.creativodigital.shop
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Legales */}
        <ul className="mt-8 flex flex-wrap gap-x-5 gap-y-2 text-[0.72rem] text-charcoal/45" data-id="element-132" data-mp="18w0c2fkta5hw">
          {LEGAL_LINKS.map(link => <li key={link.label} data-id="element-133" data-mp="l5nsu8k48mc0">
              <a href={link.href} className="transition-colors hover:text-gold-deep focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-134" data-mp="g8nny0z05pmh">
                {link.label}
              </a>
            </li>)}
        </ul>

        {/* Cierre */}
        <div className="mt-5 border-t border-stone pt-5" data-id="element-135" data-mp="2q1rmx0qkj5uk">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between" data-id="element-136" data-mp="2uz9zd13so37b">
            <p className="text-[0.72rem] text-charcoal/50" data-id="element-137" data-mp="1xbrif2zzbus8">
              © Creativo Digital™ 2026 — Todos los derechos reservados.
            </p>
            <p className="text-[0.72rem] text-charcoal/45" data-id="element-138" data-mp="22bnl8ywxxg67">
              Un producto de{' '}
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="font-semibold text-gold-deep transition-colors hover:text-gold focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-gold/40" data-id="element-139" data-mp="2795w4uuiq5gu">
                Creativo Digital
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>;
}